import { apiClient } from '@lib/axios';

import type {
  InviteDetails,
  InviteStaffRequest,
  StaffListData,
  StaffMember,
  UpdateStaffRequest,
  UpdateStaffStatusRequest,
} from '../types';

interface StaffListEnvelope {
  success: boolean;
  data: StaffListData;
}

interface StaffSingleEnvelope {
  success: boolean;
  data: { staff: StaffMember };
}

export async function listStaff(
  accountId: string,
  page = 1,
  limit = 20,
): Promise<StaffListData> {
  const { data } = await apiClient.get<StaffListEnvelope>(
    `/staff/accounts/${accountId}/staff`,
    { params: { page, limit } },
  );
  return data.data;
}

export async function inviteStaff(
  accountId: string,
  body: InviteStaffRequest,
): Promise<StaffMember> {
  const { data } = await apiClient.post<StaffSingleEnvelope>(
    `/staff/accounts/${accountId}/staff/invite`,
    body,
  );
  return data.data.staff;
}

export async function updateStaff(
  accountId: string,
  staffId: string,
  body: UpdateStaffRequest,
): Promise<StaffMember> {
  const { data } = await apiClient.put<StaffSingleEnvelope>(
    `/staff/accounts/${accountId}/staff/${staffId}`,
    body,
  );
  return data.data.staff;
}

export async function updateStaffStatus(
  accountId: string,
  staffId: string,
  body: UpdateStaffStatusRequest,
): Promise<StaffMember> {
  const { data } = await apiClient.put<StaffSingleEnvelope>(
    `/staff/accounts/${accountId}/staff/${staffId}/status`,
    body,
  );
  return data.data.staff;
}

interface InviteDetailsEnvelope {
  success: boolean;
  data: InviteDetails;
}

export async function lookUpInvite(tokenId: string): Promise<InviteDetails> {
  const { data } = await apiClient.get<InviteDetailsEnvelope>(
    `/staff/invites/${tokenId}`,
  );
  return data.data;
}

export async function revokeInvite(
  accountId: string,
  staffId: string,
): Promise<StaffMember> {
  const { data } = await apiClient.post<StaffSingleEnvelope>(
    `/staff/accounts/${accountId}/staff/${staffId}/revoke-invite`,
  );
  return data.data.staff;
}
